import { useParams, Link, Navigate } from "react-router-dom";
import { FaCheckCircle, FaBriefcase, FaClock, FaDollarSign, FaMapMarkerAlt } from "react-icons/fa";
import PageHeader from "../components/layout/PageHeader";
import { careers } from "../data/blog";

export default function CareerSingle() {
  const { id } = useParams();
  const job = careers.find((c) => c.id === id);
  if (!job) return <Navigate to="/careers" replace />;

  return (
    <>
      <PageHeader
        title={job.title}
        crumbs={[{ label: "Careers", to: "/careers" }, { label: job.title }]}
      />
      <section className="section">
        <div className="container single-layout reverse">
          <aside>
            <div className="sidebar-box">
              <h3>Job Overview</h3>
              <table className="meta-table">
                <tbody>
                  <tr><td><FaBriefcase /> Type</td><td>{job.type}</td></tr>
                  <tr><td><FaClock /> Schedule</td><td>{job.schedule}</td></tr>
                  <tr><td><FaDollarSign /> Salary</td><td>{job.salary}</td></tr>
                  <tr><td><FaMapMarkerAlt /> Location</td><td>{job.location}</td></tr>
                </tbody>
              </table>
              <Link to="/career-form" className="btn btn-primary btn-block mt-3">Apply Now</Link>
            </div>
          </aside>

          <div className="single-content">
            <h2>Job Description</h2>
            <p>{job.desc} We're looking for dedicated team members who share our commitment to safety, professionalism and outstanding customer service.</p>

            <h2>Responsibilities</h2>
            <ul className="check-list">
              {job.responsibilities.map((r, i) => <li key={i}><FaCheckCircle /> {r}</li>)}
            </ul>

            <h2>Requirements</h2>
            <ul className="check-list">
              {job.requirements.map((r, i) => <li key={i}><FaCheckCircle /> {r}</li>)}
            </ul>

            <Link to="/career-form" className="btn btn-primary mt-3">Apply for This Position</Link>
          </div>
        </div>
      </section>
    </>
  );
}
